import { render } from "./adminCounsel_picker.vue?vue&type=template&id=fbf1acc0&scoped=true"
import script from "./adminCounsel_picker.vue?vue&type=script&lang=js"
export * from "./adminCounsel_picker.vue?vue&type=script&lang=js"

import "./adminCounsel_picker.vue?vue&type=style&index=0&id=fbf1acc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbf1acc0"]])

export default __exports__